/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
import React, { useState, Fragment, useEffect } from 'react';
import {
  Label,
  Input,
  Card,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Modal,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  UncontrolledDropdown,
  DropdownToggle,
  Badge,
} from 'reactstrap';
import DocumentForm from './DocumentForm';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import {
  AxiosAPI,
  getUserID,
  getGroupID,
} from '../../../../../helpers/AxiosAPI';
import { API_Documents, gAPI_Users_By_Id } from '../../../../../constants/APIs';
import moment from 'moment';
import Validation from '../../../../../components/Validation';
import {
  faTrashAlt,
  faEdit,
  faDownload,
} from '@fortawesome/free-solid-svg-icons';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
function generateRandomColor() {
  var arr = [
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'danger',
    'light',
    'dark',
  ];
  return arr[Math.floor(Math.random() * arr.length)];
}

const DocumentList = ({ match, documentList, tags, LoadData }) => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [comments, setComemnts] = useState('');
  const [documentDetails, setDocumentDetails] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [tagsColor, setTagsColor] = useState([]);

  useEffect(() => {
    if (tags !== undefined && tags.length > 0) {
      let lst = [];
      tags.map((m, index) => {
        lst.push({
          label: m,
          color: generateRandomColor(index),
        });
      });
      setTagsColor(lst);
    }
  }, [documentList]);

  const handleDeleteToggle = () => {
    setIsDelete(!isDelete);
  };

  const handleEditToggle = () => {
    setIsEdit(!isEdit);
  };

  const handleEditClick = (details) => {
    setDocumentDetails(details);
    handleEditToggle();
  };

  const handleDeleteClick = (details) => {
    setDocumentDetails(details);
    handleDeleteToggle();
    setComemnts('');
  };

  const handleDelete = () => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((res) => {
      let body = {
        id: documentDetails.id,
        userName: res.data.fullName,
        comments: comments,
      };
      AxiosAPI({
        method: 'delete',
        url: `${API_Documents}`,
        data: body,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          handleDeleteToggle();
          LoadData();
        }
      });
    });
  };

  const handleUpdate = (item, primary) => {
    if (primary !== undefined) {
      if (primary) item.status = 'Published';
      else item.status = 'Draft';
    }

    item.modifiedBy = 'Admin';
    AxiosAPI({
      method: 'put',
      url: `${API_Documents}/${item.id}`,
      data: item,
    }).then((res) => {
      if (
        res.data.HttpStatusCode !== undefined &&
        res.data.HttpStatusCode === 400 &&
        res.data.Messages !== undefined &&
        res.data.Messages !== null &&
        res.data.Messages.length > 0
      ) {
        setMsg(res.data.Messages);
        setOpen(true);
      } else {
        LoadData();
        if (isEdit === true) handleEditToggle();
      }
    });
  };

  const getFileType = (file) => {
    if (file.includes('docx')) return 'application/msword';
    else if (file.includes('pdf')) return 'application/pdf';
    else return 'text/plain';
  };

  const getfileExtension = (file) => {
    if (file.includes('docx')) return 'docx';
    else if (file.includes('pdf')) return 'pdf';
    else return 'txt';
  };

  const handleDownload = (item) => {
    NotificationManager.success(
      '',
      'Please wait, it will take a few moments to download the document',
      3000,
      null,
      null,
      'success'
    );
    AxiosAPI({
      method: 'GET',
      url: `${API_Documents}/download/${item.id}`,
    })
      .then((response) => {
        let link = document.createElement('a');
        const mimeType = getFileType(response.data.fileName);
        link.href = `data:${mimeType};base64,${response.data.content}`;
        link.download = `${item.title}.${getfileExtension(
          response.data.fileName
        )}`;
        link.click();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      {documentList !== undefined &&
        documentList.length > 0 &&
        documentList.map((item) => (
          <Card
            className="d-flex flex-row mb-3"
            style={{ borderRadius: '10px' }}
          >
            <div className="pl-2 d-flex flex-grow-1 min-width-zero">
              <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                <p className="mb-1 ml-5  text-small w-40 w-sm-100">
                  <b>{item.title}</b>
                  <p className="mt-2">({item.id})</p>
                </p>

                <p className="mb-1 text-muted text-small w-20 w-sm-100">
                  {/* {FormsType.filter(i => i.value.includes(item.formType)).map(p => p.label)} */}
                  {item.tags.length > 0 &&
                    item.tags.map((m, i) => (
                      <Badge
                        color={
                          tagsColor.length > 0 &&
                          tagsColor.filter((f) => f.label === m)[0].color
                        }
                        className="mt-1 mr-1"
                      >
                        {m}
                      </Badge>
                    ))}
                </p>
                <p className="mb-1 text-muted text-small w-20 w-sm-100">
                  {item.creator}
                </p>
                <p className="mb-1 text-muted text-small w-20 w-sm-100">
                  {moment(item.date).format('MMM DD, YYYY hh:mm')}
                </p>
                <p className="mb-1 text-muted text-small w-10 w-sm-100">
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small"
                    checked={item.status === 'Draft' ? false : true}
                    onChange={(primary) => handleUpdate(item, primary)}
                  />
                </p>
                <div className="mb-1 w-15 w-sm-100">
                  <Button
                    color="secondary"
                    size="xs"
                    outline
                    onClick={() => handleDownload(item)}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>{' '}
                    Download
                  </Button>
                </div>
                <div className="mb-1 w-10 w-sm-100">
                  <FontAwesomeIcon
                    icon={faEdit}
                    color="#90caf9"
                    cursor="pointer"
                    onClick={() => handleEditClick(item)}
                  />
                  <Fragment>
                    <b> | </b>
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      style={{ color: 'var(--theme-color-1)' }}
                      cursor="pointer"
                      onClick={() => handleDeleteClick(item)}
                    />
                  </Fragment>

                  {/* <div className="mb-1 w-10 w-sm-100">
                                        <UncontrolledDropdown className="w-15 text-center w-sm-100" >
                                            <DropdownToggle caret color="outline-dark" size="xs">
                                                more
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem
                                                    key="edit"
                                                    onClick={() => handleEditClick(item)}
                                                >
                                                    View Details
                                                </DropdownItem>
                                                <DropdownItem
                                                    key="danger"
                                                    onClick={() => handleDeleteClick(item)}
                                                >
                                                    Delete Document
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </div> */}
                </div>
              </div>
            </div>
          </Card>
        ))}
      {isEdit && documentDetails !== undefined && (
        <DocumentForm
          taglist={tags}
          label={'Update Document'}
          documentDetails={documentDetails}
          toggle={handleEditToggle}
          submit={handleUpdate}
          visible={isEdit}
        ></DocumentForm>
      )}

      {isDelete && documentDetails !== undefined && (
        <Modal
          isOpen={isDelete}
          toggle={handleDeleteToggle}
          style={{ maxWidth: '600px' }}
        >
          <ModalHeader toggle={handleDeleteToggle}>Delete Document</ModalHeader>
          <ModalBody>
            <h6 className="mb-3">Are you sure you want to delete ?</h6>

            <div className="mb-3">
              <Label>Comments</Label>
              <Input
                type="text"
                name="comments"
                value={comments}
                onChange={(e) => {
                  setComemnts(e.target.value);
                }}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={handleDelete}>
              Delete
            </Button>
            <Button color="secondary" onClick={handleDeleteToggle}>
              Back
            </Button>
          </ModalFooter>
        </Modal>
      )}
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </>
  );
};

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps, {})(DocumentList));
